import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type ActivityCardProps = {
  description: string
  icon: React.ReactElement
  iconContainerClassname: string
  link: string
  title: string
}

export function ActivityCard({
  description,
  icon,
  iconContainerClassname,
  link,
  title,
}: ActivityCardProps): React.ReactElement {
  return (
    <plume.Link href={link} className={iconContainerClassname}>
      <CardWrapper>
        <CardIllustration>{icon}</CardIllustration>
        <CardTitle>
          <plume.styles.heading.XXS asDesktop="L">{title}</plume.styles.heading.XXS>
        </CardTitle>
        <CardDescription>
          <plume.styles.copy.S asDesktop="L">{description} </plume.styles.copy.S>
        </CardDescription>
        <plume.glyphs.stroke.ArrowRight size={24} />
      </CardWrapper>
    </plume.Link>
  )
}

const CardIllustration = styled.div`
  width: 64px;
  height: 64px;
  background-color: ${plume.COLORS.BLUE_SHADE_3};
  border: 6px solid ${plume.COLORS.PRIMARY_WHITE};
  border-radius: 10px;
  position: absolute;
  top: -20px;
  left: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.25s ease-in-out;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    width: 94px;
    height: 94px;
  }
`

const CardWrapper = styled.div`
  position: relative;
  width: 90vw;
  max-width: 528px;
  min-height: 254px;
  background-color: ${plume.COLORS.PRIMARY_WHITE};
  padding: 16px;
  border-radius: 4px;
  filter: drop-shadow(2px 4px 14px ${plume.COLORS.GREY_SHADE_1}2d);
  transition: filter 0.25s ease-in-out;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 10px 24px;
    height: 300px;
  }

  ${plume.glyphs.stroke.ArrowRight} {
    position: absolute;
    right: 24px;
    bottom: 24px;
  }

  &:hover,
  &:active {
    filter: drop-shadow(2px 4px 14px ${plume.COLORS.GREY_SHADE_5});

    ${CardIllustration} {
      background-color: ${plume.COLORS.BLUE_SHADE_1};
    }
  }
`

const CardTitle = styled.div`
  position: relative;
  top: 30px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    left: 106px;
    top: 8px;
    min-height: 60px;
    max-width: 360px;
  }
`

const CardDescription = styled.div`
  position: relative;
  top: 40px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    top: 30px;
  }
`
